export { AlarmActions } from './AlarmActions/AlarmActions';
export { Communications } from './Communications/Communications';
export { ControlZones } from './ControlZones/ControlZones';
export { General } from './General/General';
export { PassBack } from './PassBack/PassBack';
export { Reporting } from './Reporting/Reporting';
export { Setup } from './Setup/Setup';
